import React from "react";
import {observer} from "mobx-react-lite";
import "./plan-info-addons-section.scss"
import FontBody2 from "../../../../components/fonts/font-body2/font-body2";
import {FONT_COLOR, FONT_VARIANT} from "../../../../components/fonts/font-props";
import Icon from "../../../../components/icons/icon/icon";
import IconChevronDown from "../../../../components/icons/icon-chevron-down/icon-chevron-down";
import SubscriptionPlansStore from "../../stores/subscription-plans-store";
import FontBody4 from "../../../../components/fonts/font-body4/font-body4";
import {AddonStatuses, AddonStore} from "../../../accounts/addons-section/stores/addons-store-list";
import IconNext from "../../../../components/icons/icon-next/icon-next";
import FlexSpaceBetweenWrapper from "../flex-space-between-wrapper/flex-space-between-wrapper";

interface ICurrentPlanInfoAddonsSection {
    addons: AddonStore[] | undefined;
    isCurrentPlan: boolean;
}

const PlanInfoAddonsSection: React.FC<ICurrentPlanInfoAddonsSection> = observer(({addons, isCurrentPlan}) => {

    let addonsPrice = 0;
    const addonsToAdd = addons?.filter((addon) => isCurrentPlan || addon.addonStatus === AddonStatuses.Deactivated);

    const setShowAddons = () => {
        const showAddons = SubscriptionPlansStore.showMore;
        SubscriptionPlansStore.showMore = !showAddons;
    }

    addons?.forEach((addon) => {
        if (isCurrentPlan) {
            addonsPrice += addon.originalPrice;
        } else {
            if (addon.addonStatus === AddonStatuses.Deactivated) {
                addonsPrice += addon.originalPrice;
            }
        }

    });

    return (
        <div className={`plan-info-addons-section
        ${SubscriptionPlansStore.showMore && 'plan-info-show-more-active'}`}>
            <FlexSpaceBetweenWrapper>
                <FontBody2 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY2}>
                    Addons price
                </FontBody2>
                <div className={'plan-info-price'}>
                    <FontBody2 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY2}>
                        ${addonsPrice}
                    </FontBody2>
                    <FontBody2 color={FONT_COLOR.NEUTRAL3}> / month</FontBody2>
                </div>
            </FlexSpaceBetweenWrapper>
            <div
                className={`plan-info-addons-section-addons-wrapper ${!SubscriptionPlansStore.showMore ? 'plan-info-addons-section-addons-wrapper-show-less' : ''} `}>
                {
                    SubscriptionPlansStore.showMore &&
                    addons?.map(function (addon) {
                        return <div className="addons-list-wrapper" key={addon.id}>
                            {
                                (addon.addonStatus === AddonStatuses.Deactivated || isCurrentPlan) &&
                                (
                                    addon.isQuotaBased() ?
                                        <FlexSpaceBetweenWrapper>
                                            <div>
                                                <FontBody4 color={FONT_COLOR.PRIMARY2}>
                                                    {
                                                        addon.displayName
                                                    }
                                                </FontBody4>
                                            </div>
                                            <div>
                                                <FontBody4 color={FONT_COLOR.PRIMARY2}>
                                                    x
                                                </FontBody4>
                                                <FontBody4 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
                                                    {
                                                        SubscriptionPlansStore.userPlan && addon.currentUserQuota
                                                    }
                                                </FontBody4>
                                            </div>
                                        </FlexSpaceBetweenWrapper>
                                        :
                                        <FontBody4 color={FONT_COLOR.PRIMARY2}>
                                            {
                                                addon.displayName
                                            }
                                        </FontBody4>
                                )
                            }
                        </div>
                    })
                }
                {
                    SubscriptionPlansStore.showMore &&
                    addons?.map(function (addon) {
                        return <div className="addons-list-wrapper" key={addon.id}>
                            {
                                (addon.addonStatus !== AddonStatuses.Deactivated && !isCurrentPlan) &&
                                <div style={{visibility: 'hidden'}}>
                                    <FontBody4 color={FONT_COLOR.PRIMARY2}>
                                        {
                                            addon.displayName
                                        }
                                    </FontBody4>
                                </div>
                            }
                        </div>
                    })
                }
                {
                    !SubscriptionPlansStore.showMore && <>
                        {addonsToAdd &&
                            <div>
                                <FontBody4 color={FONT_COLOR.PRIMARY2}>
                                    {
                                        addonsToAdd?.length
                                    } active add-ons
                                </FontBody4>
                            </div>
                        }
                    </>
                }
            </div>
            <div className="plan-info-addons-section-expand-button-wrapper" onClick={setShowAddons}>
                {!SubscriptionPlansStore.showMore &&
                    <>
                        <div className="plan-info-addons-section-button-text">
                            <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>More
                                details</FontBody2>
                        </div>
                        <div className="plan-info-addons-section-button-icon">
                            <Icon Component={IconNext}/>
                        </div>
                    </>
                }
                {SubscriptionPlansStore.showMore &&
                    <>
                        <div className="plan-info-addons-section-button-text">
                            <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>Less
                                details</FontBody2>
                        </div>
                        <div className="plan-info-addons-section-button-icon">
                            <Icon Component={IconChevronDown}/>
                        </div>
                    </>
                }
            </div>
        </div>
    )
})

export default PlanInfoAddonsSection;